<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Pedidos</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <availability-table v-if="campaign.id" :campaign="campaign" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import AvailabilityTable from './List/AvailabilityTable';

export default {
  name: 'OrdersAvailability',
  components: {
    AvailabilityTable,
    RouteBreadCrumb,
  },

  data() {
    return {
      campaign: {},
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
  },

  mounted() {
    this.$services
      .resource('campaigns')
      .show(this.id)
      .then((res) => res.data.data)
      .then((campaign) => (this.campaign = campaign));
  },
};
</script>
